import script from "./AppKintz.vue?vue&type=script&setup=true&lang=js"
export * from "./AppKintz.vue?vue&type=script&setup=true&lang=js"

import "./AppKintz.vue?vue&type=style&index=0&id=6aa6efe9&lang=css"

const __exports__ = script;

export default __exports__